/**
 * Utility functions for getting test points
 */
import { getTestPointsForWedging } from './wedging';

/**
 * Get test points for various test types
 */
export const getTestPoints = (testId: string): string[] => {
  // Check the current path to determine the level
  const pathname = window.location.pathname;
  const isLevel1 = pathname.includes('level1');
  const isLevel2 = pathname.includes('level2');
  const isLevel3 = !isLevel1 && !isLevel2;
  
  // Wedging test have their own dedicated handler
  if (testId.includes('wedging-')) {
    return getTestPointsForWedging(testId);
  }
  
  // Level 3 specific points
  if (isLevel3) {
    // Putting tests for Level 3
    if (testId === "putts-plat") {
      return ["A", "B", "C"];
    } else if (testId === "putts-montee") {
      return ["A1", "B1", "C1"];
    } else if (testId === "putts-descente") {
      return ["A2", "B2", "C2"];
    } else if (testId === "putts-pente") {
      return ["A3", "B3", "C3"];
    } else if (testId === "putts-pente-droite") {
      return ["A4", "B4", "C4"];
    }
    
    // Chipping tests for Level 3
    if (testId === "chipping-plat") {
      return ["TerPlatA", "TerPlatB", "TerPlatC"];
    } else if (testId === "chipping-pente-droit") {
      return ["PenteDroitA1", "PenteDroitB1", "PenteDroitC1"];
    } else if (testId === "chipping-pente-gauche") {
      return ["PenteGaucheA2", "PenteGaucheB2", "PenteGaucheC2"];
    } else if (testId === "chipping-roulee-plat") {
      return ["ChipRoulA", "ChipRoulB", "ChipRoulC", "ChipRoulD"];
    } else if (testId === "chipping-roulee-pente") {
      return ["ChipRoulPenteA1", "ChipRoulPenteB1", "ChipRoulPenteC1", "ChipRoulPenteD1"];
    } else if (testId === "chipping-roulee-pente-gauche") {
      return ["ChipRoulPenteA5", "ChipRoulPenteB5", "ChipRoulPenteC5", "ChipRoulPenteD5"];
    }
    
    // Bunker tests for Level 3
    if (testId === "bunker-court") {
      return ["BunkerA", "BunkerB", "BunkerC"];
    } else if (testId === "bunker-long") {
      return ["BunkerD"];
    }
    
    // Iron tests for Level 3
    if (testId === "iron-precision") {
      return ["IronA", "IronB", "IronC"];
    } else if (testId === "iron-green-attack-100") {
      return ["IronGreenAttack100"];
    }
    
    // Fairway Wood tests for Level 3
    if (testId === "fairwayWood-precision") {
      return ["FairwayWoodA", "FairwayWoodB", "FairwayWoodC"];
    }
    
    // Driver tests for Level 3
    if (testId === "driver-precision") {
      return ["DriverA"];
    }
  }
  
  // Fallback to Level 1/2 logic for compatibility
  if (isLevel1) {
    // Putting tests for Level 1
    if (testId === "putts-plat") {
      return ["G", "H", "I"];
    } else if (testId === "putts-montee") {
      return ["G1", "H1", "I1"];
    } else if (testId === "putts-descente") {
      return ["G2", "H2", "I2"];
    } else if (testId === "putts-pente") {
      return ["G3", "H3", "I3"];
    } else if (testId === "putts-pente-droite") {
      return ["G4", "H4", "I4"];
    }
    
    // Chipping/Wedging tests for Level 1
    if (testId === "chipping-plat") {
      return ["G", "H", "I"];
    } else if (testId === "chipping-pente-droit") {
      return ["G1", "H1", "I1"];
    } else if (testId === "chipping-roulee-plat") {
      return ["G2", "H2", "I2"];
    }
    
    // Other test types
    if (testId === "wedging-cercles") {
      return ["G", "H", "I"];
    } else if (testId === "wedging-pente-gauche") {
      return ["G1", "H1", "I1"];
    } else if (testId === "wedging-mid") {
      return ["G2", "H2", "I2"];
    }
    
    // Bunker and other tests - default points
    return ["G", "H", "I"];
  } else if (isLevel2) {
    // Putting tests for Level 2
    if (testId === "putts-plat") {
      return ["D", "E", "F"];
    } else if (testId === "putts-montee") {
      return ["D1", "E1", "F1"];
    } else if (testId === "putts-descente") {
      return ["D2", "E2", "F2"];
    } else if (testId === "putts-pente") {
      return ["D3", "E3", "F3"];
    } else if (testId === "putts-pente-droite") {
      return ["D4", "E4", "F4"];
    }
    
    // Chipping tests for Level 2
    if (testId === "chipping-plat") {
      return ["D", "E", "F"];
    } else if (testId === "chipping-pente-droit") {
      return ["D1", "E1", "F1"];
    } else if (testId === "chipping-pente-gauche") {
      return ["D2", "E2", "F2"];
    } else if (testId === "chipping-roulee-plat") {
      return ["D3", "E3", "F3"];
    }
    
    // Other specific tests
    if (testId === "bunker-court") {
      return ["D", "E", "F"];
    } else if (testId === "bunker-long") {
      return ["D1", "E1"];
    }
    
    // Iron, fairwayWood, and driver simplified to D for Level 2
    if (testId.includes('iron-') || testId.includes('fairwayWood-') || testId.includes('driver-')) {
      return ["D"];
    }
    
    // Default Level 2 points
    return ["D", "E", "F"];
  }
  
  // Fallback default
  return ["G", "H", "I"];
};
